import styled from 'styled-components'
import { NEUTRAL_100 } from '@styles/colors'
import { INTER } from '@styles/fonts'

interface ContainerProps {
  $backgroundColor: string;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  color: black;
  gap: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  width: 100%;
  background-color: ${props => props.$backgroundColor};
  padding: 16px 12px;
`

export const LevelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-direction: row;
  position: relative;
`

export const LevelName = styled.span`
  font-family: ${INTER.bold};
  font-size: 24px;
`

export const BackgroundWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  right: -20px;
`
